import React from 'react';
import { useI18n } from '@/context/LanguageContext';

/**
 * Simple "TR | EN" text toggle.
 */
export const LanguageToggle = ({ className = '' }) => {
  const { lang, setLang, langs, t } = useI18n();

  return (
    <div
      role="group"
      aria-label={t('common.langLabel')}
      data-testid="language-toggle"
      className={[
        'flex items-center gap-0.5 rounded-full border border-[hsl(var(--border-soft))] bg-[hsl(var(--surface))] p-0.5',
        className,
      ].join(' ')}
    >
      {langs.map((l) => {
        const active = lang === l.id;
        return (
          <button
            key={l.id}
            type="button"
            aria-pressed={active}
            data-testid={`language-option-${l.id}`}
            onClick={() => setLang(l.id)}
            className={[
              'rounded-full px-2.5 py-1 text-[11px] font-bold tracking-wide transition-colors duration-150',
              'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[hsl(var(--brand-red))]',
              active
                ? 'bg-[hsl(var(--brand-red))] text-white'
                : 'text-[hsl(var(--text-muted))] hover:bg-[hsl(var(--surface-2))] hover:text-white',
            ].join(' ')}
          >
            {l.label}
          </button>
        );
      })}
    </div>
  );
};
